/**
 * App Store URLs for downloading the Focal mobile app.
 * Centralized for consistency across the application.
 */

export const IOS_APP_STORE_URL =
  "https://apps.apple.com/us/app/focal-secure-ai-for-advisors/id6743939027";

export const ANDROID_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.focal.app";
